<template>
  <div class="row p-1">
    <!--Campo de Datas-->
    <div class="col-sm-12 text-left mt-1 row">
      <base-input class="col-sm-6 col-12 text-left" :class="block.data_inicial === true ? 'has-danger' : ''"
        label="Data Inicial" type="date" v-model="payload.data_inicial">
      </base-input>

      <base-input class="col-sm-6 col-12 text-left" :class="block.data_final === true ? 'has-danger' : ''"
        label="Data Final" type="date" v-model="payload.data_final">
      </base-input>
    </div>

    <!--Campo Posto de Trabalho-->
    <div class="col-sm-12 text-left mt-1 form-group has-label row">
      <label>
        Posto de Trabalho
      </label>
      <el-select class="select-success mb-3 pagination-select" placeholder="Todos os postos de trabalho"
        v-model="payload.id_posto" :disabled="block.posto">
        <el-option v-for="item in postos" :key="item.id" class="select-success" :label="item.local" :value="item.id">{{
          item.local }}</el-option>
      </el-select>
    </div>

    <!--Buttons-->
    <div class="col-sm-12 text-center mt-1 row">
      <base-button type="success" class="text-center col-sm-5 col-12 animation-on-hover"
        @click="pesquisar()">Exportar</base-button>
      <base-button type="success" class="text-center col-sm-6 col-12 animation-on-hover" @click="limparFiltro">Limpar
        Filtros</base-button>
    </div>

    <!--Fim-->
  </div>
</template>

<script>
import { BaseInput } from "./index";
import { Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import Fuse from "fuse.js";


export default {
  name: "BaseFiltroExportacao",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
    Modal
  },
  props: {
  },
  data() {
    return {
      dadosUsuario: "",
      fuseSearch: null,
      emails: "",
      block: {
        departamento: true,
        posto: true,
        funcionario: true,
        emails: "",
        data_final: "",
        data_inicial: ""
      },
      departamentos: [],
      postos: [],
      imagens: [],
      funcionarios: [],
      payload: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
        emails: [""],
        empresasRestrincao: [],
        idUsuario: ""
      },
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarDepartamentos();
    this.listarPostos();
    this.listarFuncionarios();
  },
  methods: {
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    selecionarFuncionario(result) {
      if (result) {
        this.payload.id_funcionario = result.id;
        return result.nome;
      }
      else return "";
    },
    procurarFuncionario(result) {
      if (result)
        return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1)
        return this.fuseSearch.search(input);
      else {
        this.payload.id_funcionario = "";
        return this.funcionarios;
      }
    },
    listarDepartamentos() {
      let th = this;
      this.block.departamento = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.block.departamento = false;
          th.departamentos = response.data.data.dados;
        })
        .catch((err) => {
          th.block.departamento = false;
          console.log(err);
        });
    },
    listarPostos() {
      this.block.posto = true;
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.block.posto = false;
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.block.posto = false;
        });
    },
    listarFuncionarios() {
      let th = this;
      this.block.funcionario = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: ""
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData)
        .then((response) => {
          th.block.funcionario = false;
          th.funcionarios = response.data.data.dados;

          th.fuseSearch = new Fuse(th.funcionarios, {
            keys: ["nome", "cpf"],
            threshold: 0.3,
          });
        })
        .catch((err) => {
          th.block.funcionario = false;
        });
    },
    validarCampos() {
      let status = true;
      // validando datas
      if (this.payload.data_final == "") {
        this.block.data_final = true;
        status = false;
      } else {
        this.block.data_final = false;
      }

      if (this.payload.data_inicial == "") {
        this.block.data_inicial = true;
        status = false;
      } else {
        this.block.data_inicial = false;
      }

      return status;

    },
    pesquisar() {
      if (this.validarCampos()) {
        this.payload.setDB = this.$cookies.get("db");
        this.payload.id_empregador = this.$cookies.get("idEmpregador");

        if (this.dadosUsuario) {
          this.payload.idUsuario = this.dadosUsuario.id;
        }

        this.$emit("pesquisar", this.payload);
      }
    },
    imprimir() {
      this.$emit("imprimir", true);
    },
    limparFiltro() {
      // document.querySelector('.autocomplete input').value = "";
      this.payload = {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: ""
      }
    }
  },
};
</script>
<style>
.autocomplete-result {
  cursor: default;
  padding: 12px 12px 12px 12px;
  background-image: none;
}

.autocomplete-input {
  height: 38px;
  font-size: 14px;
  border: 1px solid #2b3553;
  border-radius: 5px;
  padding: 12px 12px 12px 12px;
  box-sizing: border-box;
  position: relative;
  line-height: 1.5;
  flex: 1;
  background: none;
}
</style>
